'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');
var SVGIcon = require('@arrive/svg-icon');
var ARRIVE = require('@arrive/ui-icons/svg/arrive_logo_solo.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var ARRIVE__default = /*#__PURE__*/_interopDefaultLegacy(ARRIVE);

var styles = {"ethanol":"arrive_LoadingSpinner__ethanol","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"arrive_LoadingSpinner__roadhog","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","processingText":"arrive_LoadingSpinner__processingText","animationContainer":"arrive_LoadingSpinner__animationContainer","innerAnimation":"arrive_LoadingSpinner__innerAnimation","arriveLogo":"arrive_LoadingSpinner__arriveLogo","savingAnimation":"arrive_LoadingSpinner__savingAnimation","saving--animation":"arrive_LoadingSpinner__saving--animation","backgroundCircle":"arrive_LoadingSpinner__backgroundCircle","animatingCircle":"arrive_LoadingSpinner__animatingCircle","progress--animation":"arrive_LoadingSpinner__progress--animation"};

function LoadingSVG() {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("svg", {
    className: styles.savingAnimation,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default["default"].createElement("circle", {
    className: styles.backgroundCircle,
    cx: "50",
    cy: "50",
    r: "45"
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    className: styles.animatingCircle,
    cx: "50",
    cy: "50",
    r: "45"
  })));
}

function LoadingSpinner(_ref) {
  var savingText = _ref.savingText,
      className = _ref.className,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'ethanol' : _ref$theme;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.animationContainer, className, styles[theme])
  }, /*#__PURE__*/React__default["default"].createElement(LoadingSVG, null), /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.innerAnimation
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    svgRef: ARRIVE__default["default"],
    className: styles.arriveLogo
  }), savingText && /*#__PURE__*/React__default["default"].createElement("p", {
    className: styles.processingText
  }, savingText)));
}
LoadingSpinner.propTypes = {
  savingText: PropTypes__default["default"].string,
  className: PropTypes__default["default"].string
};

module.exports = LoadingSpinner;
